export const AppActions = {
  SCREEN_RESIZE: "app/screenResize",
};

export const screenResize = (screenWidth: number) => ({
  type: AppActions.SCREEN_RESIZE,
  payload: { screenWidth },
});
